const Host = "https://api.anokhihomes.net"
// const Host = "http://localhost:8000"
export default Host;